import gql from 'graphql-tag'

const caseStudyList = gql`query GetCaseStudyList {
  caseStudy {
    displayText
    path
    blurb
    thumbnailImage {
      urls
    }
    relatedServices {
      contentItems {
        ... on Service {
          displayText
        }
      }
    }
  }
}`

const caseStudyDetail = gql`query GetCaseStudyDetail($path: String!) {
  caseStudy(where: { path: $path }) {
    displayText
    blurb
    intro {
      html
    }
    relatedServices {
      contentItems {
        ... on Service {
          displayText
          path
        }
      }
    }
    thumbnailImage {
      urls
    }
    bag {
      contentItems {
        ... on ContentBlockFlowpart {
          displayText
          image {
            urls
          }
          contentBlockSubtitle
          markdownBody {
            html
          }
          sectionStyle
        }
        ... on Accordion {
          displayText
          subtitle
          accordionContent {
            contentItems {
              ... on AccordionItem {
                displayText
                markdownBody {
                  html
                }
              }
            }
          }
        }
        ... on Image {
          displayText
          images {
            urls
          }
        }
        ... on Buttons {
          buttonList {
            contentItems {
              displayText
              ... on LinkMenuItem {
                linkMenuItem {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
}`

export {
  caseStudyList,
  caseStudyDetail
}